/** @jsxImportSource @emotion/react */

import { searchTransactionsQueryDocument } from 'api/graphql';
import { useMemo, useState } from 'react';
import { useQuery } from 'urql';

import { SearchFilter, SearchFilterOption, SearchFilterProps } from './SearchFilter';

export type TransactionFilterProps = {
  merchantIds: string | string[];
  value: SearchFilterOption | null;
  onChange(value: SearchFilterOption | null): void;
};

export function TransactionFilter({ merchantIds, value, onChange, ...props }: TransactionFilterProps) {
  const [query, setQuery] = useState('');

  const pause = query.length < 3;

  const [{ fetching, data, error }] = useQuery({
    query: searchTransactionsQueryDocument,
    variables: { merchantIds, query },
    pause,
  });

  const options = useMemo<SearchFilterProps['options']>(() => {
    if (pause || !data?.transactions) return [];

    return data.transactions.edges.map(({ node: { transactionId } }) => ({
      value: transactionId,
      label: transactionId,
    }));
  }, [data?.transactions, pause]);

  return (
    <SearchFilter
      value={value}
      options={options}
      placeholder="Search transaction ID"
      loading={fetching}
      error={error?.message}
      onChange={onChange}
      onInputChange={setQuery}
    />
  );
}
